<template>
  <div>
    <section class="">
      <div class="container">
        <ul class="btn-box">
          <li>
            <router-link :to="{ name: 'MemberInfo' }" tag="button">
              <img src="img/member-icon-1.svg" alt="" />
              {{ $t("會員資料") }}
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'OrderList' }"
              tag="button"
              class="active"
            >
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("我的套票") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CardInfo' }" tag="button">
              <img src="img/member-icon-6.svg" alt="" />
              {{ $t("卡片資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Coupon' }" tag="button">
              <img src="img/member-icon-8.svg" alt="" />
              {{ $t("套票兌換") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'TradeRecord' }" tag="button">
              <img src="img/member-icon-4.svg" alt="" />
              {{ $t("卡片交易紀錄") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CarbonReduction' }" tag="button">
              <img src="img/member-icon-9.png" alt="" />
              {{ $t("減碳計算") }}
            </router-link>
          </li>
          <li></li>
        </ul>
        <div class="main">
          <!-- 0622 新增 bg-box -->
          <div class="bg-box">
            <h1>{{ $t("搭乘紀錄") }}</h1>
          </div>
          <hr style="display: block" />
          <div
            class="bg-box result-box"
            style="display: block"
            v-if="!IsLoaded"
          >
            <h1>{{ $t("讀取中...") }}</h1>
          </div>
          <div
            class="bg-box result-box"
            style="display: block"
            v-if="IsLoaded && ErrorMsg != ''"
          >
            <h1>{{ ErrorMsg }}</h1>
          </div>
          <div
            class="bg-box result-box"
            style="display: block"
            v-if="IsLoaded && ErrorMsg == ''"
          >
            <h1>{{ $t("查詢結果") }}</h1>
            <div class="result">
              <ul
                class="text-box"
                v-for="TicketLog in TicketLogs"
                :key="TicketLog.TxnSN"
              >
                <li>
                  <div>{{ TicketLog.TxnDT }}</div>
                  <div v-if="TicketLog.TxnType == 0">{{ $t("進站") }}</div>
                  <div v-if="TicketLog.TxnType == 1">{{ $t("出站") }}</div>
                  <div v-if="TicketLog.TxnType == 2">{{ $t("消費") }}</div>
                  <div v-if="TicketLog.TxnType == 3">{{ $t("退款") }}</div>
                  <div>
                    {{ TicketLog.RouteCN + " " + TicketLog.LocationCN }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
    zh_tw: {
    "會員資料": "會員資料",
    "我的套票": "我的套票",
    "卡片資料": "卡片資料",
    "套票兌換": "套票兌換",
    "卡片交易記錄": "卡片交易記錄",
    "其他資訊": "其他資訊",
    "搭乘紀錄": "搭乘紀錄",
    "讀取中...": "讀取中...",
    "查詢結果": "查詢結果",
    "進站": "進站",
    "出站": "出站",
    "消費": "消費",
    "退款": "退款",
    "錯誤": "錯誤",
    "取得搭乘紀錄過程發生錯誤, 請稍後再試一次": "取得搭乘紀錄過程發生錯誤, 請稍後再試一次",
    "確定": "確定",
    "卡片交易紀錄": "卡片交易紀錄",
    "減碳計算": "減碳計算",
  },
  en: {
    "會員資料": "Member info",
    "我的套票": "My pass",
    "卡片資料": "Card info",
    "套票兌換": "Redeem pass",
    "卡片交易記錄": "Card record",
    "其他資訊": "Other info",
    "搭乘紀錄": "Transportation record",
    "讀取中...": "Reading...",
    "查詢結果": "Query result",
    "進站": "Enter",
    "出站": "Exit",
    "消費": "Purchase",
    "退款": "Refund",
    "錯誤": "Error",
    "取得搭乘紀錄過程發生錯誤, 請稍後再試一次": "Error. Please try again.",
    "確定": "Confirm",
    "卡片交易紀錄": "Activity",
    "減碳計算": "Carbon Reduced",
  },
  jp: {
    "會員資料": "會員資料",
    "我的套票": "我的套票",
    "卡片資料": "卡片資料",
    "套票兌換": "套票兌換",
    "卡片交易記錄": "卡片交易記錄",
    "其他資訊": "其他資訊",
    "搭乘紀錄": "搭乘紀錄",
    "讀取中...": "讀取中...",
    "查詢結果": "查詢結果",
    "進站": "進站",
    "出站": "出站",
    "消費": "消費",
    "退款": "退款",
    "錯誤": "錯誤",
    "取得搭乘紀錄過程發生錯誤, 請稍後再試一次": "取得搭乘紀錄過程發生錯誤, 請稍後再試一次",
    "確定": "確定",
    "卡片交易紀錄": "卡片交易紀錄",
    "減碳計算": "減碳計算",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "TicketLog",
  i18n,
  data() {
    return {
      TicketLogs: {},
      ErrorMsg: "",
      IsLoaded: false,
      local: "zh_tw",
      IsTester: false,
    };
  },
  created: function () {
    let that = this;
    $.ajax({
      url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/TicketLog",
      //url: "https://localhost:44321/Html/TicketLog",
      type: "post",
      data: {
        TId: this.$route.params.TId,
        token: Storage.get("ek_login_token"),
      },
      dataType: "json",
      error: function () {
        that.$swal({
          heightAuto: false,
          title: that.$t("錯誤"),
          text: that.$t("取得搭乘紀錄過程發生錯誤, 請稍後再試一次"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
        });
      },
      success: function (res) {
        // 判斷結果
        if (res.ok) {
          that.TicketLogs = JSON.parse(res.TicketLogs);
          that.IsTester = res.IsTester;
        } else if (res.error_msg) {
          var error_msg = JSON.parse(res.error_msg);
          if (res.toekn_error) {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              willClose: function () {
                // 移除登入資訊
                Storage.remove("ek_login_token");
                // 回到首頁
                that.$router.push({
                  name: "Home",
                  params: {},
                });
              },
            });
          } else {
            that.ErrorMsg = res.error;
          }
        }
        // 設為已載入
        that.IsLoaded = true;
      },
    });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("member");
    $(".wrapper").addClass("member-record");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
    this.local = i18n.locale;
  },
  methods: {
    timeString(time, format) {
      return moment(time).format(format || "YYYY-MM-DD, HH:mm:ss");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/TicketLog.vue